var Animations = {
  init: function() {
    var total_animated_words = jQuery('.animated-text-container span').length;
    var animation_duration = (10*total_animated_words)/5;
    var keyframe = Math.round(100/animation_duration);
    keyframe = Math.floor(keyframe/2);
    return keyframe;
  },
  bottom_bottom: function(current_item, start_frame) {
    var keyframe = Animations.init();
    var bottom_bottom = {
      name: 'cycle-'+current_item
    };
    var start = 2*Math.floor(keyframe/2);
    if(start_frame !== 0) {
      start = parseInt(start_frame);
    }
    var start_animation = parseInt(start+keyframe);
    var stay_time = start_animation+parseInt(keyframe*2);
    var remove_frame = parseInt(stay_time+keyframe);
    bottom_bottom['0%'] = { 'top': '80px' };
    bottom_bottom[start+'%'] = { 'top': '80px', 'opacity': '1' };
    bottom_bottom[start_animation+'%'] = { 'top': '0px', 'z-index':'0', 'opacity': '1' };
    bottom_bottom[stay_time+'%'] = { 'top': '0px', 'z-index':'0', 'opacity': '1' };
    bottom_bottom[remove_frame+'%'] = { 'top': '80px', 'z-index': '-1' };
    bottom_bottom['100%'] = { 'top': '80px', 'z-index': '-1' };
    var animation_data = {'bottom_bottom' : bottom_bottom, 'remove_frame' : remove_frame};
    return animation_data;

  },
  top_left: function(current_item, start_frame) {
    var keyframe = Animations.init();
    var top_left = {
      name: 'cycle-'+current_item
    };
    var start = 2*Math.floor(keyframe/2);
    if(start_frame !== 0) {
      start = parseInt(start_frame);
    }
    var start_animation = parseInt(start+keyframe);
    var stay_time = start_animation+parseInt(keyframe*2);
    var remove_frame = parseInt(stay_time+keyframe);

    top_left['0%'] = { 'top': '-80px' };
    top_left[start+'%'] = { 'top': '-80px' };
    top_left[start_animation+'%'] = { 'top': '0px', 'opacity': '1' };
    top_left[stay_time+'%'] = { 'top': '0px', 'left':'0px', 'z-index': '0', 'opacity': '1' };
    top_left[remove_frame+'%'] = { 'top': '0px', 'right': 'auto', 'left':'-100%', 'z-index': '-1' };
    top_left['100%'] = { 'left': '-100%', 'z-index': '-1', 'opacity': '0' };
    var animation_data = {'top_left' : top_left, 'remove_frame' : remove_frame};
    return animation_data;
  },
  bottom_right: function(current_item, start_frame) {

    var keyframe = Animations.init();
    var bottom_right = {
      name: 'cycle-'+current_item
    };

    var start = 2*Math.floor(keyframe/2);
    if(start_frame !== 0) {
      start = parseInt(start_frame);
    }

    var start_animation = parseInt(start+keyframe);
    var stay_time = start_animation+parseInt(keyframe*2);
    var remove_frame = parseInt(stay_time+keyframe);


    bottom_right['0%'] = { 'top': '80px' };
    bottom_right[start+'%'] = { 'top': '80px' };
    bottom_right[start_animation+'%'] = { 'top': '0px', 'opacity': '1' };
    bottom_right[stay_time+'%'] = { 'top': '0px', 'left':'0px', 'z-index': '0', 'opacity': '1' };
    bottom_right[remove_frame+'%'] = { 'top': '0px', 'right': 'auto', 'left':'100%', 'z-index': '-1' };
    bottom_right['100%'] = { 'left': '100%', 'right':'auto', 'z-index': '-1', 'opacity': '0' };
    var animation_data = {'bottom_right' : bottom_right, 'remove_frame' : remove_frame};
    return animation_data;

  },
  top_bottom: function(current_item, start_frame) {

    var keyframe = Animations.init();
    var top_bottom = {
      name: 'cycle-'+current_item
    };

    var start = 2*Math.floor(keyframe/2);
    if(start_frame !== 0) {
      start = parseInt(start_frame);
    }

    var start_animation = parseInt(start+keyframe);
    var stay_time = start_animation+parseInt(keyframe*2);
    var remove_frame = parseInt(stay_time+keyframe);

    top_bottom['0%'] = { 'top': '-80px' };
    top_bottom[start+'%'] = { 'top': '-80px' };
    top_bottom[start_animation+'%'] = { 'top': '0px', 'opacity': '1' };
    top_bottom[stay_time+'%'] = { 'top': '0px', 'left':'0px', 'z-index': '0', 'opacity': '1' };
    top_bottom[remove_frame+'%'] = { 'top': '0px', 'right': 'auto', 'left':'-100%', 'z-index': '-1' };
    top_bottom['100%'] = { 'left': '-100%', 'z-index': '-1', 'opacity': '0' };
    var animation_data = {'top_bottom' : top_bottom, 'remove_frame' : remove_frame};
    return animation_data;
  }

};

